import React from 'react'
import ShowingCard from '../components/ShowingCard'

const listEvents = (events, myID, loadIndex, history) => {
  // console.log(events)
  return events
    .filter(event => event.creator_id === myID)
    .sort((a, b) => b.id - a.id)
    .map((event, index) =>
      index <= loadIndex ? (
        <ShowingCard key={event.id} data={event} history={history} />
      ) : (
        ''
      )
    )
}

export default listEvents
